import { InvestmentsTable } from './components/InvestmentsTable';

export const ManageInvestments = () => {
	return <InvestmentsTable />;
};
